import { Routes } from '@angular/router';
import { UserProfileComponent } from '../user/containers/user-profile/user-profile.component';
import { userRoleAdminGuard } from '../user/user-role-admin.guard';
import { userRoleGuard } from '../user/user-role.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./containers/features/features.component').then(
        (m) => m.FeaturesComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.routes').then((mod) => mod.ROUTES),
        canActivateChild: [userRoleGuard],
      },
      {
        path: 'contacts',
        canActivateChild: [userRoleGuard],
        loadChildren: () =>
          import('./contacts/contacts.routes').then((m) => m.routes),
      },

      {
        path: 'agreements',
        loadChildren: () =>
          import('./agreements/agreements.routes').then((m) => m.routes),
        canActivateChild: [userRoleGuard],
      },
      {
        path: 'contracts',
        loadChildren: () =>
          import('./contracts/contracts.routes').then((m) => m.routes),
      },
      {
        path: 'addresses',
        loadChildren: () =>
          import('./addresses/addresses.routes').then((m) => m.routes),
        canActivateChild: [userRoleGuard],
      },
      {
        path: 'items',
        loadChildren: () =>
          import('./items/items.routes').then((m) => m.routes),
      },
      {
        path: 'logs',
        canActivate: [userRoleGuard, userRoleAdminGuard],
        loadChildren: () => import('./logs/logs.routes').then((m) => m.routes),
      },
      {
        path: 'history',
        canActivate: [userRoleGuard, userRoleAdminGuard],
        loadChildren: () =>
          import('./history/history.routes').then((m) => m.routes),
      },
      {
        path: 'varietals',
        canActivate: [userRoleGuard, userRoleAdminGuard],
        loadChildren: () =>
          import('./varietals/varietals.routes').then((m) => m.routes),
      },
      {
        path: 'appellations',
        canActivate: [userRoleGuard, userRoleAdminGuard],
        loadChildren: () =>
          import('./appellations/appellations.routes').then((m) => m.routes),
      },
      {
        path: 'samples',
        canActivateChild: [userRoleGuard],
        loadChildren: () =>
          import('./samples/samples.routes').then((m) => m.routes),
      },
      {
        path: 'sampleShipmentRequests',
        // canActivateChild: [userRoleGuard],
        loadChildren: () =>
          import(
            './sample-shipment-requests/sample-shipment-requests.routes'
          ).then((m) => m.routes),
      },
      {
        path: 'sampleShipments',
        loadChildren: () =>
          import('./sample-shipments/sample-shipments.routes').then(
            (m) => m.routes
          ),
      },
      {
        path: 'invoices',
        loadChildren: () =>
          import('./invoices/invoices.routes').then((m) => m.routes),
        canActivateChild: [userRoleGuard],
      },
      {
        path: 'buySpecs',
        loadChildren: () =>
          import('./buy-specs/buy-specs.routes').then((m) => m.routes),
      },
      {
        path: 'companies',
        loadChildren: () =>
          import('./companies/company.routes').then((m) => m.routes),
        canActivateChild: [userRoleGuard],
      },
      {
        path: 'reminders',
        loadChildren: () =>
          import('./reminders/reminders.routes').then((m) => m.routes),
        canActivateChild: [userRoleGuard],
      },
      {
        path: 'shipmentFulfillments',
        loadChildren: () =>
          import('./shipment-fulfillments/shipment-fulfillments.routes').then(
            (m) => m.routes
          ),
        canActivateChild: [userRoleGuard],
      },
      {
        path: 'sampleTracking',
        loadChildren: () =>
          import('./sample-tracking/sample-tracking.routes').then(
            (m) => m.routes
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./users/users.routes').then((m) => m.routes),
        canActivate: [userRoleGuard, userRoleAdminGuard],
      },
      {
        path: 'user-profile',
        component: UserProfileComponent,
      },
      {
        path: 'aperture',
        loadChildren: () =>
          import('./aperture/aperture.routes').then((m) => m.routes),
        canActivateChild: [userRoleGuard],
      },
      {
        path: 'settings',
        loadComponent: () =>
          import(
            './settings/containers/settings-home/settings-home.component'
          ).then((m) => m.SettingsHomeComponent),
      },
      {
        path: 'wip',
        loadChildren: () => import('./wip/wip.module').then((m) => m.WipModule),
      },
      {
        path: 'samplesReplenishment',
        loadChildren: () =>
          import('./samples-replenishment/samples-replenishment.routes').then(
            (m) => m.routes
          ),
        canActivateChild: [userRoleGuard],
      },
    ],
  },
];
